/* src/app/components/client-tracking-data/client-tracking-data.component.scss */
.tracking-container {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  background: #fff;
}
.tracking-container .text-info-wrapper {
  display: flex;
  gap: 0.75rem;
}
.tracking-container .bold-text {
  color: #000;
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.tracking-container .bold-text.green {
  color: #0acf83;
}
.tracking-container .regular-text {
  color: #949494;
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.tracking-container .progress-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
  padding: 0 6rem 0 6rem;
  gap: 1.25rem;
}
.tracking-container .progress-wrapper .progressBar-wrapper {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 8rem;
  position: relative;
  margin-bottom: 1.75rem;
}
.tracking-container .progress-wrapper .progressBar-wrapper .progressBar {
  width: 100%;
  border-radius: 50px;
  height: 30px;
  position: absolute;
  bottom: 0;
}
.tracking-container .progress-wrapper .progressBar-wrapper .progressBar.barBackground {
  background-color: #e5e5e5;
}
.tracking-container .progress-wrapper .progressBar-wrapper .progressBar.barFill {
  background-color: #0acf83;
}
.tracking-container .progress-wrapper .progressBar-wrapper .marker {
  bottom: 50%;
  transform: translate(-50%, 50%);
  z-index: 2;
}
.tracking-container .progress-wrapper .progressBar-wrapper .marker .marker-text {
  position: absolute;
  left: 50%;
  transform: translate(-50%, -60px);
  white-space: nowrap;
  color: #949494;
  text-align: center;
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.tracking-container .progress-wrapper .progressBar-wrapper .marker .text2 {
  transform: translate(-50%, -35px);
  color: #ff007f;
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.tracking-container .progress-wrapper .progressBar-wrapper .marker .icon-container {
  width: 70px;
  height: 70px;
  border-radius: 100%;
  border: 3px solid #cbcbcb;
  padding: 8px;
  background: white;
}
.tracking-container .progress-wrapper .progressBar-wrapper .marker .icon-container.completed {
  border: 3px solid #0acf83;
}
.tracking-container .progress-wrapper .progressBar-wrapper .marker .icon-container ion-icon {
  width: 100%;
  height: 100%;
}
.tracking-container .progress-wrapper .progressBar-wrapper .marker.truck {
  transform: translate(0, 50%);
}
.tracking-container .progress-wrapper .progressBar-wrapper .marker.truck .icon-container {
  border-width: 0;
  padding: 0;
  background: transparent;
}
.tracking-container .progress-wrapper .progressBar-wrapper .marker.truck.flipped {
  transform: translate(0, 50%) rotateY(180deg);
}
.tracking-container.vertical {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  background: #fff;
  padding-left: 25px;
}
.tracking-container.vertical .text-info-wrapper {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}
.tracking-container.vertical .bold-text {
  font-size: 16px;
}
.tracking-container.vertical .progress-wrapper {
  padding: 30px 0 0 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
}
.tracking-container.vertical .progress-wrapper .progressBar-wrapper {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 14rem;
  position: relative;
  margin-bottom: 1.75rem;
}
.tracking-container.vertical .progress-wrapper .progressBar-wrapper .progressBar {
  width: 30px;
  border-radius: 50px;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  bottom: unset;
}
.tracking-container.vertical .progress-wrapper .progressBar-wrapper .progressBar.barBackground {
  background-color: #e5e5e5;
}
.tracking-container.vertical .progress-wrapper .progressBar-wrapper .progressBar.barFill {
  background-color: #0acf83;
}
.tracking-container.vertical .progress-wrapper .progressBar-wrapper .marker {
  height: fit-content;
  bottom: 50%;
  transform: translate(-10px, -50%);
  z-index: 2;
}
.tracking-container.vertical .progress-wrapper .progressBar-wrapper .marker .marker-text-wrapper {
  display: flex;
  flex-direction: column;
  left: 80px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.tracking-container.vertical .progress-wrapper .progressBar-wrapper .marker .marker-text {
  left: unset;
  position: relative;
  transform: unset;
  white-space: nowrap;
  color: #949494;
  text-align: center;
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.tracking-container.vertical .progress-wrapper .progressBar-wrapper .marker .text2 {
  transform: unset;
  color: #ff007f;
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.tracking-container.vertical .progress-wrapper .progressBar-wrapper .marker .icon-container {
  width: 50px;
  height: 50px;
  border-radius: 100%;
  border: 3px solid #cbcbcb;
  padding: 8px;
  background: white;
}
.tracking-container.vertical .progress-wrapper .progressBar-wrapper .marker .icon-container.completed {
  border: 3px solid #0acf83;
}
.tracking-container.vertical .progress-wrapper .progressBar-wrapper .marker .icon-container ion-icon {
  width: 100%;
  height: 100%;
}
.tracking-container.vertical .progress-wrapper .progressBar-wrapper .marker.truck {
  transform: translate(-10px, -30%);
}
.tracking-container.vertical .progress-wrapper .progressBar-wrapper .marker.truck .icon-container {
  border-width: 0;
  padding: 0;
  background: transparent;
  transform: scale(0.65);
}
.tracking-container.vertical .progress-wrapper .progressBar-wrapper .marker.truck.flipped {
  transform: translate(-10px, -30%) rotateY(180deg);
}
.trackingLink {
  color: #0c8ce9;
  text-align: center;
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 16px;
  font-weight: 500;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
}
.separator {
  width: 100%;
  height: 1px;
  background: #cbcbcb;
}
.christmas-message {
  text-align: center;
  color: #949494;
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 18px;
  font-weight: 400;
}
/*# sourceMappingURL=client-tracking-data.component-W3R75JGB.css.map */
